module.exports = __webpack_public_path__ + "img/3.f831f17d.png";